export const apiErrorValue = {
  isError: false,
  statusCode: null,
  message: "",
};
